import { JsonProperty } from '../../core/services/utils/mapping.service';

export class Entity {
  @JsonProperty('id')
  id: number = 0;
  @JsonProperty('name')
  name: string = '';
}
